import { IActivity } from '../../../../../../App/store/features/activity/interface/IActivityList'
import { IActivityMetaData } from '../../../../../../App/store/features/activity/interface/IActivityState'
import { IAppointment, IAppointmentActivity } from '../../../../../types'

export const getActivitiesFromAppointment = (
  appointmentDetails: IAppointment,
  activityList: IActivity[],
): IAppointmentActivity[] =>
  appointmentDetails.appointmentActivity.map(activity => {
    const activityDetails: IActivity | undefined = activityList.find(
      activityItem => activityItem.id === activity.activityId,
    )
    const activityMetaData: IActivityMetaData = activityDetails || {
      name: 'Deleted',
      color: '#333333',
    }

    return {
      personId: activity.personId,
      isLocked: activity.isLocked,
      startsAt: activity.startsAt,
      endsAt: activity.endsAt,
      appointmentId: activity.appointmentId,
      id: activity.id,
      activityId: activity.activityId,
      name: activityMetaData.name,
      color: activityMetaData.color,
      appointmentActivityUuid: activity.appointmentActivityUuid,
    }
  })
